import { Scene, WebXRDefaultExperience, WebXRState, Mesh } from "@babylonjs/core";

export class XRManager {
  private scene: Scene;
  xr: WebXRDefaultExperience | undefined;

  constructor(scene: Scene) {
    this.scene = scene;
  }

  async init(floorMeshes: Mesh[]): Promise<void> {
    const supported: boolean = await this.isSupported();
    if (!supported) {
      console.warn("[XR] WebXR 'immersive-vr' not supported in this browser. Running flat-screen.");
      return;
    }

    const xr: WebXRDefaultExperience = await this.scene.createDefaultXRExperienceAsync({
      floorMeshes,
      disableTeleportation: false,
    });
    this.xr = xr;

    xr.baseExperience.onStateChangedObservable.add((state: WebXRState) => {
      console.log(`[XR] state → ${WebXRState[state]}`);
    });
  }

  private async isSupported(): Promise<boolean> {
    const xr: XRSystem | undefined = (navigator as Navigator & { xr?: XRSystem }).xr;
    if (xr === undefined) {
      return false;
    }
    try {
      return await xr.isSessionSupported("immersive-vr");
    } catch {
      return false;
    }
  }
}
